import { useEffect } from 'react';

// React component that runs badge killer in component lifecycle
export const BadgeKiller = () => {
  useEffect(() => {
    const hideBadge = () => {
      try {
        // Target by ID
        const badgeById = document.getElementById('emergent-badge');
        if (badgeById) {
          badgeById.style.cssText = 'display:none !important; visibility:hidden !important; opacity:0 !important; pointer-events:none !important;';
          badgeById.remove();
        }

        // Target by selectors
        const selectors = [
          '[id*="emergent"]',
          '[class*="emergent"]',
          'a[href*="emergent.sh"]',
          'a[href*="app.emergent"]',
        ];

        selectors.forEach((selector) => {
          const elements = document.querySelectorAll(selector);
          elements.forEach((el) => {
            if (el && el.textContent && el.textContent.includes('Emergent')) {
              el.style.cssText = 'display:none !important; visibility:hidden !important; opacity:0 !important; pointer-events:none !important;';
              try {
                el.remove();
              } catch (e) {
                // Silent fail
              }
            }
          });
        });

        // Heuristic scan for fixed badges
        if (document.body) {
          const fixed = document.querySelectorAll('body > *');
          fixed.forEach((elem) => {
            const computed = window.getComputedStyle(elem);
            
            if (computed.position === 'fixed') {
              const zIndex = parseInt(computed.zIndex) || 0;
              const bottom = computed.bottom;
              const right = computed.right;
              const width = parseInt(computed.width) || 0;
              const height = parseInt(computed.height) || 0;
              
              // Badge characteristics
              if (zIndex > 999 && 
                  bottom && bottom !== 'auto' && parseInt(bottom) < 100 &&
                  right && right !== 'auto' && parseInt(right) < 100 &&
                  width < 300 && height < 120) {
                
                const content = elem.textContent || '';
                if (content.length < 50 && content.includes('Emergent')) {
                  elem.style.cssText = 'display:none !important; visibility:hidden !important; opacity:0 !important;';
                  try {
                    elem.remove();
                  } catch (e) {
                    // Silent fail
                  }
                }
              }
            }
          });
        }
      } catch (error) {
        // Silent fail
      }
    };

    // Run immediately
    hideBadge();

    // Create observer
    const observer = new MutationObserver((mutations) => {
      let shouldRun = false;
      mutations.forEach((mutation) => {
        if (mutation.addedNodes.length > 0) {
          shouldRun = true;
        }
      });
      
      if (shouldRun) {
        requestAnimationFrame(hideBadge);
      }
    });

    // Start observing
    observer.observe(document.documentElement, {
      childList: true,
      subtree: true,
    });

    // Run periodically
    const interval = setInterval(hideBadge, 300);

    // Cleanup
    return () => {
      observer.disconnect();
      clearInterval(interval);
    };
  }, []);

  return null;
};
